import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentCohortPathSelector } from '../Auth/selectors';
import { selectCurrentCoursePath } from '../Courses/selectors';
import { enrolmentsSelector } from '../Enrolments/selectors';

export const cohortsSelector = (state) => state.Cohorts;

export const currentCohortSelector = createSelector(
  cohortsSelector,
  currentCohortPathSelector,
  (cohorts, currentCohort) => {
    return cohorts.get(currentCohort, null);
  }
);

export const currentCourseCohortsByPathSelector = createSelector(
  cohortsSelector,
  selectCurrentCoursePath,
  (cohorts, currentCourse) => {
    return cohorts.filter(
      (cohort) => cohort.get('coursePath') === currentCourse
    );
  }
);

export const currentCourseCohortsSelector = createSelector(
  currentCourseCohortsByPathSelector,
  (cohorts) => cohorts.toList()
);

export const cohortsByIdSelector = createSelector(
  cohortsSelector,
  (cohorts) => {
    return cohorts.reduce(
      (current, value) => current.set(value.get('id'), value),
      Immutable.Map()
    );
  }
);

export const currentUserEnrolledCohortsSelector = createSelector(
  enrolmentsSelector,
  currentCourseCohortsByPathSelector,
  (enrolments, courseCohorts) => {
    let enrolledCohorts = Immutable.Map();

    enrolments.forEach((enrolment) => {
      enrolledCohorts = enrolledCohorts.set(
        enrolment.get('cohortPath'),
        enrolment.get('timestamp')
      );
    });

    // sort by enrolment timestamps to match existing behaviour
    return courseCohorts
      .filter((cohort) => enrolledCohorts.has(cohort.get('path')))
      .toList()
      .sortBy((cohort) => enrolledCohorts.get(cohort.get('path')))
      .reverse();
  }
);

export const selectCohortsByCoursePath = createSelector(
  cohortsSelector,
  (cohorts) => {
    return cohorts.reduce(
      (byCoursePath, cohort) =>
        byCoursePath.setIn(
          [cohort.get('coursePath'), cohort.get('path')],
          cohort
        ),
      Immutable.Map()
    );
  }
);
